export default __webpack_public_path__ + "static/media/23.ff6ab346.jpg";